import { render, staticRenderFns } from "./base-radio-group.vue?vue&type=template&id=e8d44606"
import script from "./base-radio-group.ts?vue&type=script&lang=ts&external"
export * from "./base-radio-group.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports